import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Button,
  DropdownMenu,
  enqueueToaster,
  IconButton,
  TextField,
} from "@deere/isg.component-library";
import {
  IconChevronLeft,
  IconCircleClose,
  IconClose,
  LocationPin,
  IconRefresh,
  IconSave,
} from "@deere/icons/new";
import "./PropertiesPanel.css";
import { setTempPoints } from "../../../mapInterface/MapInterface";

import { useMap } from "@vis.gl/react-google-maps";
import HeadingSelector from "./HeadingSelector";
import useApiCall from "../../../hooks/useApiCall";

let mapClickListenerActive = false;
let clickListener: any = null;

function AddPropertiesPanel({
  currentTopicString,
  propertyType,
  selectedProperty,
  setSelectedProperty,
  handleClose,
  changeFirstPanel,
}: {
  currentTopicString: any;
  propertyType: String;
  selectedProperty: any;
  setSelectedProperty: (object: any) => void;
  handleClose: () => void;
  changeFirstPanel: () => void;
}) {
  const [propertyName, setPropertyName] = useState("");
  const [propertyDescription, setPropertyDescription] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  // const [propertyType, setPropertyType] = useState(selectedProperty?.type || '');
  // const [zoneOptions, setZoneOptions] = useState(['FREE_SPACE_ZONE', 'RESTRICTED_ZONE', 'BOUNDARY', 'OI_OBJECT', 'WORK_ZONE']);
  const [zoneOptions, setZoneOptions] = useState([
    "Free Space Zone",
    "Restricted Zone",
    "Boundary",
    "OI Object",
    "Work Zone",
  ]);
  // const [lineOptions, setLineOptions] = useState(['NAVIGABLE_PATH', 'WINDROW', 'STATIC_ROUTE']);
  const [lineOptions, setLineOptions] = useState(["Navigable Path", "Windrow", "Static Route"]);
  const [alertVisible, setAlertVisible] = useState(true);
  const [alertVisibleAllFields, setAlertVisibleAllFields] = useState(false);
  const map = useMap("mainMap"); // Get the map instance
  const [points, setPoints] = useState<google.maps.LatLng[]>([]);
  const [point, setPoint] = useState<google.maps.LatLng | null>(null);
  const pointsRef = useRef(points); // Create a ref to hold the latest points
  const pointRef = useRef(point); // Create a ref to hold the latest point
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [heading, setHeading] = useState(0); // Store heading in degrees

  const [propertyTypeEnum, setPropertyTypeEnum] = useState(0);
  const enumMap: { [key: string]: number } = {
    "Free Space Zone": 0,
    "Restricted Zone": 1,
    Boundary: 2,
    "OI Object": 3,
    "Work Zone": 4,
    "Navigable Path": 0,
    Windrow: 1,
    "Static Route": 2,
    "Dump Point": 0,
    "Load Point": 1,
  };

  const backendURI = process.env.REACT_APP_STRIPPED_BACKEND_URI;
  const { execute } = useApiCall({ errorAsToast: true });

  interface PolylineProps {
    points: string; // A string representing the points of the polyline, e.g., "10,10 190,10 160,190 40,190"
    stroke?: string; // Optional stroke color for the line
    strokeWidth?: number; // Optional stroke width for the line
  }

  const Polyline: React.FC<PolylineProps> = ({
    points,
    stroke = "black", // Default stroke color
    strokeWidth = 2, // Default stroke width
  }) => {
    return (
      <svg width="32" height="32" viewBox="0 0 200 200">
        <polyline
          points={points}
          fill="none" // No fill for the polyline
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  };

  interface PolygonProps {
    points: string; // A string representing the points of the polygon, e.g., "50,150 100,50 150,150"
    fill?: string; // Optional fill color for the polygon
    stroke?: string; // Optional stroke color for the polygon
    strokeWidth?: number; // Optional stroke width for the polygon
  }

  const Polygon: React.FC<PolygonProps> = ({
    points,
    fill = "lightblue", // Default fill color
    stroke = "black", // Default stroke color
    strokeWidth = 1, // Default stroke width
  }) => {
    return (
      <svg width="32" height="32" viewBox="0 0 200 200">
        <polygon points={points} fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
      </svg>
    );
  };

  useEffect(() => {
    // Update the ref to the latest points
    pointsRef.current = points;
  }, [points]); // Update ref whenever points change

  useEffect(() => {
    // Update the ref to the latest points
    pointRef.current = point;
  }, [point]); // Update ref whenever points change

  useEffect(() => {
    console.log(point);
    if (propertyType == "Point") {
      if (
        point !== null &&
        propertyName !== "" &&
        propertyDescription !== "" &&
        selectedOption !== ""
      ) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      if (
        points.length > 1 &&
        propertyName !== "" &&
        propertyDescription !== "" &&
        selectedOption !== ""
      ) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    }
  }, [point, points, propertyName, propertyDescription, selectedOption]);

  useEffect(() => {
    // This is the effect to draw points on the map
    if (map) {
      let tempFeature = map.data.getFeatureById("temporaryBoundaryID");
      if (tempFeature) {
        // Found the current feature
        tempFeature.setGeometry(new google.maps.Data.LineString(points));

        // Setting the temp Point icons on the map
        let newPoints: any[] = [];
        points.map((thisPoint) => {
          console.log(thisPoint.lat());
          console.log(thisPoint.lng());
          newPoints.push(getPointItem(thisPoint));
        });
        console.log("Calling setTempPoints");
        setTempPoints(newPoints);
      } else {
        // Creates a new Polygon feature
        let myPolygon = new google.maps.Data.LineString(points);
        let myFeatureOptions: google.maps.Data.FeatureOptions = {
          geometry: myPolygon,
          id: "temporaryBoundaryID", //This is a custom id randomly generated
          properties: {
            zoneType: "TEMPORARY",
          },
        };
        let myNewFeature = new google.maps.Data.Feature(myFeatureOptions);
        map.data.setStyle({
          strokeColor: "#f2a900",
          strokeWeight: 6,
          zIndex: 10,
        });
        map.data.add(myNewFeature);

        // Setting the temp Point icons on the map
        let newPoints: any[] = [];
        points.map((thisPoint) => {
          newPoints.push(getPointItem(thisPoint));
        });
        console.log("Calling setTempPoints");
        setTempPoints(newPoints);
      }

      // Adding points to the map for each user click
      // points.map((point) => {
      //     // let thisNewMarker = new google.maps.Point(point.lat(),point.lng());
      //     // map.data.add(thisNewMarker)
      //     // google.maps.marker.AdvancedMarkerElement
      //     // let thisPoint = new google.maps.marker.AdvancedMarkerElement({map: map, position: point});
      //     // console.log(point);
      // })
    }
  }, [points]);

  function getPointItem(thisPoint: google.maps.LatLng | null) {
    let tempIcon = (
      <LocationPin
        style={{
          position: "relative",
          top: "12px",
          minHeight: "45px",
          minWidth: "45px",
          height: "auto",
          width: "auto",
        }}
      />
    );
    let tempLat = 0;
    let tempLng = 0;
    if (thisPoint) {
      tempLat = thisPoint?.lat() || 0;
      tempLng = thisPoint?.lng() || 0;
    }

    let newPoint = {
      position: {
        lat: tempLat,
        lng: tempLng,
      },
      referenceDiv: <div style={{ minHeight: "45px", minWidth: "45px" }}>{tempIcon}</div>,
      callback: () => console.log("Clicked the Point!"),
    };
    return newPoint;
  }

  useEffect(() => {
    if (map) {
      setTempPoints([getPointItem(point)]);
    }
  }, [point]);

  function clearTemporaryPointsAndLines() {
    if (map) {
      let tempFeature = map.data.getFeatureById("temporaryBoundaryID");
      if (tempFeature) {
        tempFeature.setGeometry(new google.maps.Data.LineString([]));
      }
    }
  }

  // useEffect(() => {
  //     if (selectedProperty) {
  //         setPropertyName(selectedProperty.name);
  //         // setPropertyType(selectedProperty.type);
  //         setSelectedOption(selectedProperty.option); // Assuming the selected option needs to be tracked
  //     }
  // }, [selectedProperty]);

  // const handleSave = () => {
  //     const updatedProperty = {
  //         ...selectedProperty,
  //         name: propertyName,
  //         type: propertyType,
  //         option: selectedOption
  //     };
  //     setSelectedProperty(updatedProperty);
  //     // Additional save logic can go here (e.g., API call)
  // };

  function handleZoneSelection(zoneTypeSelected: string) {
    console.log(enumMap[zoneTypeSelected]);
    setSelectedOption(zoneTypeSelected as string);
    setPropertyTypeEnum(enumMap[zoneTypeSelected]);
  }

  // ['Free Space Zone', 'Restricted Zone', 'Boundary', 'OI Object', 'Work Zone']

  const zoneItems = [
    {
      // Boundary
      onClick: () => handleZoneSelection("Boundary"),
      id: "2",
      title: "Boundary",
      subtitle: "An defined area",
      icon: (
        <Polygon
          points="50,50 150,20 200,100 150,180 50,150"
          stroke="#FFD700" // Gold
          strokeWidth={4}
          fill="#FFFACD" // Light Yellow
        />
      ),
    },
    {
      // Free Space Zone
      onClick: () => handleZoneSelection("Free Space Zone"),
      id: "0",
      title: "Free Space Zone",
      subtitle: "An easily navigatable area",
      icon: (
        <Polygon
          points="50,50 150,20 200,100 150,180 50,150"
          stroke="#32CD32" // Lime Green
          strokeWidth={4}
          fill="#90EE90" // Light Green
        />
      ),
    },
    {
      // Work Zone
      onClick: () => handleZoneSelection("Work Zone"),
      id: "4",
      title: "Work Zone",
      subtitle: "Typical operation area",
      icon: (
        <Polygon
          points="50,50 150,20 200,100 150,180 50,150"
          stroke="#FF8C00" // Dark Orange
          strokeWidth={6}
          fill="#FFE4B5" // Lemon Chiffon
        />
      ),
    },
    {
      // Restricted Zone
      onClick: () => handleZoneSelection("Restricted Zone"),
      id: "1",
      title: "Restricted Zone",
      subtitle: "An area to never traverse",
      icon: (
        <Polygon
          points="50,50 150,20 200,100 150,180 50,150"
          stroke="#FF4500" // Orange Red
          strokeWidth={6}
          fill="#FFCCCB" // Light Red
        />
      ),
    },
    {
      // OI Object
      onClick: () => handleZoneSelection("OI Object"),
      id: "3",
      title: "OI Object",
      subtitle: "An identified obstacle",
      icon: (
        <Polygon
          points="50,50 150,20 200,100 150,180 50,150"
          stroke="#1E90FF" // Dodger Blue
          strokeWidth={6}
          fill="#ADD8E6" // Light Blue
        />
      ),
    },
  ];

  // ['Navigable Path', 'Windrow', 'Static Route']
  const lineItems = [
    {
      // Navigable Path
      onClick: () => handleZoneSelection("Navigable Path"),
      id: "0",
      title: "Navigable Path",
      subtitle: "A path that can be followed",
      icon: (
        <Polyline
          points="50,150 100,100 150,130 200,80"
          stroke="#32CD32" // Lime Green
          strokeWidth={4}
        />
      ),
    },
    {
      // Windrow
      onClick: () => handleZoneSelection("Windrow"),
      id: "1",
      title: "Windrow",
      subtitle: "A pass taken by a grading machine",
      icon: (
        <Polyline
          points="50,150 100,100 150,130 200,80"
          stroke="#FF4500" // Orange Red
          strokeWidth={4}
        />
      ),
    },
    {
      // Static Route
      onClick: () => handleZoneSelection("Static Route"),
      id: "2",
      title: "Static Route",
      subtitle: "A route that will not change",
      icon: (
        <Polyline
          points="50,150 100,100 150,130 200,80"
          stroke="#FFD700" // Gold
          strokeWidth={4}
        />
      ),
    },
  ];

  // ['Dump Point', 'Load Point']
  // DUMP_POINT = 0;
  // LOAD_POINT = 1;
  const pointItems = [
    {
      // Navigable Path
      onClick: () => handleZoneSelection("Dump Point"),
      id: "0",
      title: "Dump Point",
      subtitle: "A point for material delivery",
      icon: (
        <LocationPin
          primary={"#FFFFFF"}
          style={{
            position: "relative",
            top: "12px",
            minHeight: "45px",
            minWidth: "45px",
            height: "auto",
            width: "auto",
          }}
        />
      ),
    },
    {
      // Windrow
      onClick: () => handleZoneSelection("Load Point"),
      id: "1",
      title: "Load Point",
      subtitle: "A point for truck loading",
      icon: (
        <LocationPin
          primary={"#FFFFFF"}
          sx={{
            position: "relative",
            top: "12px",
            minHeight: "45px",
            minWidth: "45px",
            height: "auto",
            width: "auto",
          }}
        />
      ),
    },
  ];

  // Listen for clicks on the map to add points

  function getClickListener(currentListene: any) {
    if (propertyType === "Point") {
      if (!mapClickListenerActive) {
        mapClickListenerActive = true;
        return map?.addListener("click", (mouseEvent: { latLng: any }) => {
          const latLng = mouseEvent.latLng;
          const newPoint = new google.maps.LatLng(latLng.lat(), latLng.lng());
          setPoint(newPoint); // Update the points list
          console.log(newPoint);
          console.log(`Boundary point added at Lat: ${latLng.lat()}, Lng: ${latLng.lng()}`);
        });
      } else {
        return currentListene;
      }
    } else {
      if (!mapClickListenerActive) {
        mapClickListenerActive = true;
        return map?.addListener("click", (mouseEvent: { latLng: any }) => {
          const latLng = mouseEvent.latLng;
          const newPoint = new google.maps.LatLng(latLng.lat(), latLng.lng());
          setPoints((prevPoints) => [...prevPoints, newPoint]); // Update the points list
          console.log(newPoint);
          console.log(`Boundary point added at Lat: ${latLng.lat()}, Lng: ${latLng.lng()}`);
        });
      } else {
        return currentListene;
      }
    }
  }

  clickListener = getClickListener(clickListener);

  // const clickListener = map?.addListener('click', (mouseEvent: { latLng: any; }) => {
  //     const latLng = mouseEvent.latLng;
  //     const newPoint = new google.maps.LatLng(latLng.lat(), latLng.lng());
  //     setPoints((prevPoints) => [...prevPoints, newPoint]); // Update the points list
  //     console.log(`Boundary point added at Lat: ${latLng.lat()}, Lng: ${latLng.lng()}`);
  // });

  async function handleSave() {
    console.log("I am saving");
    setIsSaving(true);

    console.log("propertyName: " + propertyName);
    console.log("propertyDescription: " + propertyDescription);

    if (
      (points || point) &&
      propertyName !== "" &&
      propertyDescription !== "" &&
      selectedOption !== ""
    ) {
      const latestPoints = pointsRef.current;
      const latestPoint = pointRef.current;

      let apiFn: (() => Promise<Response>) | null = null;

      if (latestPoints.length > 0) {
        if (propertyType === "Zone") {
          apiFn = () =>
            fetch("https://" + backendURI + "/Save/BoundaryNew", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                zoneType: propertyTypeEnum,
                pointsArray: latestPoints,
                currentTopicString: currentTopicString + "Shape/" + propertyName.toString(),
                deleted: false,
                description: propertyDescription,
              }),
            });
        } else if (propertyType === "Line") {
          apiFn = () =>
            fetch("https://" + backendURI + "/Save/LineNew", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                zoneType: propertyTypeEnum,
                pointsArray: latestPoints,
                currentTopicString: currentTopicString + "Line/" + propertyName.toString(),
                deleted: false,
                description: propertyDescription,
              }),
            });
        }
      } else if (latestPoint !== null && propertyType === "Point") {
        apiFn = () =>
          fetch("https://" + backendURI + "/Save/PointNew", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              pointType: propertyTypeEnum,
              lat: latestPoint.lat(),
              lng: latestPoint.lng(),
              heading: heading,
              currentTopicString: currentTopicString + "Point/" + propertyName.toString(),
              deleted: false,
              description: propertyDescription,
            }),
          });
      }

      if (apiFn) {
        const success = await execute(apiFn, {
          successMessage: propertyType + " saved successfully",
        });
        if (success) {
          clearTemporaryPointsAndLines();
          handleLocalClose();
        }
      }
      setIsSaving(false);
    } else {
      console.log("Failed check for send!");
      setAlertVisibleAllFields(true);
      setIsSaving(false);
    }
  }

  function handleClear() {
    setPoints([]); // Clear the points array
  }

  async function handleLocalClose() {
    console.log("Boundary creation canceled!");
    await clickListener?.remove();
    if (clickListener) {
      console.log("Click Listener Not Removed!");
      await clickListener.remove();
      await google.maps.event.removeListener(clickListener);
    }
    mapClickListenerActive = false;
    clickListener = null;
    setPoints([]); // Clear the points
    setTempPoints([]); // Clear Map Point Icons

    handleClose();
  }

  // if (propertyType === 'Zone' && map) {

  //     async function savePoints(pointsArray: any) {
  //         // const url = 'http://localhost/API/Save/Boundary'; // Replace with your actual endpoint
  //         const url = 'https://' + backendURI + '/Save/Boundary';

  //         try {
  //             const response = await fetch(url, {
  //                 method: 'POST',
  //                 headers: {
  //                     'Content-Type': 'application/json', // Specify that the content type is JSON
  //                 },
  //                 body: JSON.stringify({
  //                     pointsArray: pointsArray,
  //                     currentTopicString: currentTopicString + "Shape/" + Math.floor(Math.random() * 99999999).toString()
  //                 }), // Convert the pointsArray to JSON
  //             });

  //             // Check if the response is successful
  //             if (!response.ok) {
  //                 throw new Error(`HTTP error! Status: ${response.status}`);
  //             }

  //             const data = await response.json(); // Parse the JSON response
  //             console.log('Points saved successfully:', data);
  //         } catch (error) {
  //             console.error('Error saving points:', error);
  //         }
  //     }

  //     // Create buttons and add them to the map
  //     // const saveButton = document.createElement('button');
  //     // saveButton.innerText = 'Save';
  //     // saveButton.className = "mapSaveButton";
  //     // saveButton.onclick = () => {
  //     //     const latestPoints = pointsRef.current; // Access latest points from ref
  //     //     console.log(latestPoints);
  //     //     if (latestPoints.length > 0) {
  //     //         // createNewBoundary(points); // Call the function to create a new boundary with the points
  //     //         savePoints(latestPoints);
  //     //     } else {
  //     //         console.log('No points to save.');
  //     //     }

  //     //     setPoints([]); // Clear the points
  //     //     console.log('Boundary creation canceled!');
  //     //     // Remove buttons from the map
  //     //     saveButton.remove();
  //     //     clearButton.remove();
  //     //     cancelButton.remove();
  //     //     clickListener.remove();
  //     //     // google.maps.event.removeListener(clickListener);
  //     // };

  //     // const clearButton = document.createElement('button');
  //     // clearButton.innerText = 'Clear';
  //     // clearButton.className = "mapClearButton";
  //     // clearButton.onclick = () => {
  //     //     setPoints([]); // Clear the points array
  //     //     console.log('Boundary points cleared!');
  //     // };

  //     // const cancelButton = document.createElement('button');
  //     // cancelButton.innerText = 'Cancel';
  //     // cancelButton.className = "mapCancelButton";
  //     // cancelButton.onclick = () => {
  //     //     setPoints([]); // Clear the points
  //     //     console.log('Boundary creation canceled!');
  //     //     // Remove buttons from the map
  //     //     saveButton.remove();
  //     //     clearButton.remove();
  //     //     cancelButton.remove();
  //     //     clickListener.remove();
  //     //     // google.maps.event.removeListener(clickListener);
  //     // };

  //     // // Append buttons to the map container
  //     // const mapContainer = document.getElementById('mainMap');
  //     // if (mapContainer) {
  //     //     mapContainer.appendChild(saveButton);
  //     //     mapContainer.appendChild(clearButton);
  //     //     mapContainer.appendChild(cancelButton);
  //     // }
  // }

  function closeAlert() {
    setAlertVisible(false);
  }

  function closeAlertAllFields() {
    setAlertVisibleAllFields(false);
  }

  return (
    <div className="PropertiesPanel">
      <div className="TopPanel">
        <div className="TopTitleBar">
          <div className="TitleBarLeft">
            <IconButton
              icon={
                <span>
                  <IconChevronLeft size={24} />
                </span>
              }
              variant="borderless"
              onClick={handleLocalClose}
              style={{ width: "32px", height: "32px" }}
            />
            <div className="PropertyTag">
              <div className="PropertyText">
                <b>Add {propertyType || "Property"}</b>
              </div>
            </div>
          </div>
          <div className="exitButtons">
            {/* <IconButton
                            icon={<IconCircleClose />}
                            variant='tertiary' onClick={handleClose} /> */}
            <IconButton
              icon={
                <span>
                  <IconCircleClose size={18} />
                </span>
              }
              variant="borderless"
              onClick={handleLocalClose}
            />
          </div>
        </div>
        <div className="ButtonPanel">
          <Button
            disabled={isDisabled || isSaving}
            loading={isSaving}
            startIcon={<IconSave size={20} />}
            style={{
              marginLeft: "6px",
              marginRight: "6px",
              backgroundColor: "#ffde00",
              color: "black",
              border: "none",
            }}
            variant="primary"
            className="SaveMissionButton"
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            startIcon={<IconRefresh size={20} />}
            style={{ marginLeft: "6px", marginRight: "6px", color: "black", border: "none" }}
            variant="secondary"
            className="SaveMissionButton"
            onClick={handleClear}
          >
            Clear
          </Button>
          <Button
            startIcon={<IconClose size={20} />}
            style={{ marginLeft: "6px", marginRight: "6px", color: "black", border: "none" }}
            variant="secondary"
            className="SaveMissionButton"
            onClick={handleLocalClose}
          >
            Cancel
          </Button>
        </div>
      </div>

      <div className="textFields">
        {alertVisible && (
          <Alert severity={"info"} onClose={() => setAlertVisible(false)}>
            {"Click on the map to create the " + (propertyType || "Property")}
          </Alert>
        )}
        {alertVisible === true && alertVisibleAllFields === true && <br></br>}
        {alertVisibleAllFields && (
          <Alert onClose={() => setAlertVisibleAllFields(false)} severity={"warning"}>
            {"Make sure to add all Fields, and points"}
          </Alert>
        )}

        <TextField
          label={(propertyType || "Property") + " Name"}
          onChange={(event) => setPropertyName(event.target.value)}
          placeholder="Enter a property name"
          value={propertyName}
          style={{ width: "373px", padding: "16px 0px 0px 0px" }}
        />
        <TextField
          label={(propertyType || "Property") + " Description"}
          onChange={(event) => setPropertyDescription(event.target.value)}
          placeholder="Enter a description of the property"
          value={propertyDescription}
          style={{ width: "373px", padding: "16px 0px 0px 0px" }}
        />
      </div>
      {propertyType === "Zone" && (
        <div className="dropdownContainer">
          <div className="SectionTitle2">Zone Type</div>
          <DropdownMenu
            buttonTitle={selectedOption || "Select Zone Option"}
            // items={zoneOptions.map(option => ({
            //     id: option,
            //     title: option,
            //     onClick: () => setSelectedOption(option)
            // }))}
            items={zoneItems}
          />
        </div>
      )}
      {propertyType === "Line" && (
        <div className="dropdownContainer">
          <div className="SectionTitle2">Line Type</div>
          <DropdownMenu
            buttonTitle={selectedOption || "Select Line Option"}
            // items={lineOptions.map(option => ({
            //     id: option,
            //     title: option,
            //     onClick: () => setSelectedOption(option)
            // }))}
            items={lineItems}
          />
        </div>
      )}
      {propertyType === "Point" && (
        <div className="dropdownContainer">
          <div className="SectionTitle2">Point Type</div>
          <DropdownMenu
            buttonTitle={selectedOption || "Select Line Option"}
            // items={lineOptions.map(option => ({
            //     id: option,
            //     title: option,
            //     onClick: () => setSelectedOption(option)
            // }))}
            items={pointItems}
          />
          <br />
          <br />
          <HeadingSelector heading={heading} setHeading={setHeading} />
        </div>
      )}
    </div>
  );
}

export default AddPropertiesPanel;
